<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="tilemagnet_breadcrumb" />
    </div>

    <div class="outterBox">
      <div class="header">
        <!--      <h1 class="overlay">SPECIAL SOUVENIR</h1>-->
        <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
        <div class="headerimage" />
      </div>

      <div class="container contentDesc">
        <div class="title1">
          <h2>
            <strong>포도호텔 타일마그넷</strong>
          </h2>
        </div>
      </div>

      <div class="container">
        <div class="w-100 d-inline-block mb-5 mx-auto">
          <GallerySlideCarousels :slides="slides" :slide-count="1" :thumb-slide-width="15" />

          <div class="text-left border-bottom mt-5">
            <h5 style="line-height: 3">
              포도호텔만의 아름다운 풍경과 공간의 의미를 감성적인 그림체와 색상으로 표현한 마그넷입니다.<br />
              포도호텔에서 남긴 소중한 추억을 간직해 보시기 바랍니다.
            </h5>
          </div>

          <div class="web text-left mt-3">
            <p>
              상품구성 : (단품) 타일마그넷 1EA<br />
              &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (세트) 타일마그넷
              6EA(1set) + 액자
            </p>
          </div>

          <div class="mobile text-left mt-3">
            <p>
              상품구성<br />
              (단품) 타일마그넷 1EA<br />
              (세트) 타일마그넷 6EA(1set)<br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+ 액자
            </p>
          </div>

          <div class="mt-4 text-white" style="background-color: #6c717b; padding: 30px">
            <h5 style="margin: 0">
              ※ 포도호텔 굿즈 상품은 포도호텔 로비에서 현장 구매 가능하며, 온라인 판매는 제공되지 않습니다.
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import GallerySlideCarousels from '@/components/GallerySlideCarousels';

export default {
  name: 'Tilemagnet',
  data() {
    return {
      tilemagnet_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'SPECIAL OFFERS > 호텔기념품',
        present: '포도호텔 타일마그넷',
      },

      slides: [{image: require('@/assets/images/Podohotel/tilemagnet_bodyimage01.jpg')}],
    };
  },
  components: {Breadcrumb, GallerySlideCarousels},
};
</script>

<style scoped lang="scss">
p,
h1,
h2,
h3,
h4,
h5 {
  word-break: keep-all;
}
.main-ex-desc {
  vertical-align: bottom;
}

.header {
  position: relative;
  width: 100%;
  padding-top: 5rem;
  > img {
    width: 100%;
  }

  .overlay {
    padding-top: 0rem;
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }

  .headerimage {
    display: block;
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/Podohotel/hotelsouvenir_haederimage.png');
  }
}

.contentDesc {
  padding-top: 3rem;
  padding-bottom: 1rem;
  text-align: center;
}

.outterBox {
}
@media (min-width: 992px) {
  .web {
  }
  .mobile {
    display: none;
  }
}
@media (max-width: 992px) {
  .header {
    display: none;
  }
  .outterBox {
    padding-top: 5rem;
  }

  h2 {
    font-size: 1.5rem !important;
  }

  h3 {
    font-size: 1.3rem !important;
  }

  h5 {
    line-height: 1.6rem !important;
    font-size: 1rem !important;
  }
  .web {
    display: none;
  }
  .mobile {
  }
}
</style>
